// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   CardContent,
//   CardMedia,
//   Typography,
//   Box,
//   Button,
//   IconButton,
//   Divider,
//   CircularProgress,
// } from "@mui/material";
// import { useParams ,useNavigate} from "react-router-dom";
// import axios from "axios";
// import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
// import ShareIcon from "@mui/icons-material/Share";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import CallIcon from "@mui/icons-material/Call";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import { BASE_URL } from "../../Api/ApiUrls";
// // Import your bottom navbar
// import BottomNavbar from "./../Rent Module/BottomNavbar/BottomNavbar";
// import DownloadIcon from "@mui/icons-material/Download";
// import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
// import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';

// const BANK_API = `${BASE_URL}/auction-property/`;
  
// const AuctionPropertyCardDynamic = () => {
//   const { id } = useParams();
//   const [property, setProperty] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [locationLoading, setLocationLoading] = useState(false);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [allImages, setAllImages] = useState([]);
//     const navigate = useNavigate();
//         const [showSuccess, setShowSuccess] = useState(false);
//       const [showFailure, setShowFailure] = useState(false);
//       const [alertMessage, setAlertMessage] = useState('');
    

// useEffect(() => {
//   const fetchProperty = async () => {
//     try {
//       const res = await axios.get(BANK_API);
      
//       // Get the data array from response
//       const dataArray = res.data?.data || res.data?.results || res.data;
      
//       // Only proceed if it's an array
//       if (Array.isArray(dataArray)) {
//         const found = dataArray.find((item) => String(item.bankprop_id) === id);
        
//         if (found) {
//           setProperty(found);
          
//           if (found.bank_pro_doc && found.bank_pro_doc.length > 0) {
//             const images = found.bank_pro_doc.map(doc => ({
//               id: doc.doc_id,
//               url: doc.document,
//               uploaded_at: doc.uploaded_at
//             }));
//             setAllImages(images);
//           } else {
//             setAllImages([]);
//           }
//         }
//       }
      
//       setLoading(false);
//     } catch (err) {
//       console.error("Error fetching property:", err);
//       setLoading(false);
//     }
//   };
//   fetchProperty();
// }, [id]);

//   const formatPropertyId = (id) => {
//     return `BAP${String(id).padStart(4, '0')}`;
//   };

//   const handleLocationClick = () => {
//     if (!property || !property.lat || !property.long) {
//       window.alert("Location coordinates not available");
//       return;
//     }
    
//     setLocationLoading(true);
    
//     const openInMaps = (url) => {
//       setLocationLoading(false);
//       window.open(url, '_blank', 'noopener,noreferrer');
//     };

//     const locationString =  `${property.lat},${property.long}`;
//     const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationString)}`;
    
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const userLat = position.coords.latitude;
//           const userLng = position.coords.longitude;
          
//           const mapsUrl = property.lat && property.long
//             ? `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${property.lat},${property.long}&travelmode=driving`
//             : fallbackUrl;
//           openInMaps(mapsUrl);
//         },
//         (error) => {
//           console.error("Error getting location:", error);
//           openInMaps(fallbackUrl);
//         },
//         { timeout: 10000 }
//       );
//     } else {
//       openInMaps(fallbackUrl);
//     }
//   };
// const handleCallButtonClick = () => {
//   if (property?.bank_contact_details) {
//     navigator.clipboard.writeText(property.bank_contact_details)
//       .then(() => {
//         setAlertMessage(
//           `Contact number copied: ${property.bank_contact_details}\n\nProperty ID: ${formatPropertyId(property.bankprop_id)}`
//         );
//         setShowSuccess(true);
//       })
//       .catch((err) => {
//         console.error("Failed to copy:", err);

//         setAlertMessage("Failed to copy contact number");
//         setShowFailure(true);
//       });
//   } else {
//     setAlertMessage("Contact number not available");
//     setShowFailure(true);
//   }
// };

//   // Format the image URL
//   const getImageUrl = (imagePath) => {
//     if (!imagePath) return null;
    
//     if (imagePath.startsWith('http')) {
//       return imagePath;
//     }
    
//     return `${BASE_URL}${imagePath}`;
//   };

//   // Carousel navigation
//   const nextImage = () => {
//     setCurrentImageIndex((prevIndex) => 
//       prevIndex === allImages.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   const prevImage = () => {
//     setCurrentImageIndex((prevIndex) => 
//       prevIndex === 0 ? allImages.length - 1 : prevIndex - 1
//     );
//   };

//   // Handle image click to navigate
//   const handleImageClick = (index) => {
//     setCurrentImageIndex(index);
//   };

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }
  
//   if (!property) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center' }}>
//         <Typography>Property not found</Typography>
//       </Box>
//     );
//   }

//   const currentImage = allImages.length > 0 ? allImages[currentImageIndex] : null;

//   const handleDownloadImage = async () => {
//   if (!currentImage) return;

//   try {
//     const imageUrl = getImageUrl(currentImage.url);

//     const response = await fetch(imageUrl);
//     const blob = await response.blob();

//     const link = document.createElement("a");
//     link.href = window.URL.createObjectURL(blob);
//     link.download = `/Auction_Property_${formatPropertyId(property.bankprop_id)}_${currentImageIndex + 1}.png`;

//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   } catch (error) {
//     console.error("Download failed:", error);
//     window.alert("Failed to download image");
//   }
// };


//   return (
//     <Box sx={{ 
//       height: '100vh', 
//       display: 'flex', 
//       flexDirection: 'column',
//       pb: 7
//     }}>
//       {/* Fixed Header */}
//       <Box
//         sx={{
//           backgroundColor: "black",
//           color: "#fff",
//           px: 2,
//           py: 1.5,
//           display: "flex",
//           alignItems: "center",
//           gap: 1,
//           position: 'sticky',
//           top: 0,
//           zIndex: 1000,
//           flexShrink: 0,
//         }}
//       >
//         <IconButton
//           size="small"
//           sx={{ color: "#fff" }}
//           onClick={() => window.history.back()}
//         >
//           <ArrowBackIosNewIcon fontSize="small" />
//         </IconButton>

//         <Typography fontWeight={600} flexGrow={1}>
//           Auction Property
//         </Typography>

//         <Box textAlign="right">
//           <Typography variant="caption">
//             ID: {formatPropertyId(property.bankprop_id)}
//           </Typography>
//          <Typography variant="caption" display="block">
//   Date:{" "}
//   {new Date(property.created_at).toLocaleDateString("en-GB")}
// </Typography>
//         </Box>
//       </Box>

//       {/* Scrollable Content */}
//       <Box sx={{ 
//         flex: 1,
//         overflowY: 'auto',
//         overflowX: 'hidden',
//         mx: "auto",
//         width: '100%',
//         maxWidth: 420,
//       }}>
//         <Card sx={{ boxShadow: 4, borderRadius: 0, border: 'none' }}>
//           <Box sx={{ p: 2 }}>
//             {/* Image Carousel */}
//             <Box position="relative" sx={{ height: 190, borderRadius: 2, overflow: 'hidden' }}>
//               {allImages.length > 0 ? (
//                 <>
//                   <CardMedia
//                     component="img"
//                     height="190"
//                     image={getImageUrl(currentImage.url)}
//                     alt={`Property ${currentImageIndex + 1}`}
//                     sx={{ 
//                       borderRadius: 2,
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover'
//                     }}
//                     onError={(e) => {
//                       e.target.src = 'https://via.placeholder.com/400x200?text=Image+Not+Available';
//                     }}
//                   />
                  

//                   {/* Download Button */}
// <IconButton
//   onClick={handleDownloadImage}
//   sx={{
//     position: "absolute",
//     top: 8,
//     right: 8,
//     backgroundColor: "rgba(0,0,0,0.6)",
//     color: "#fff",
//     "&:hover": {
//       backgroundColor: "rgba(0,0,0,0.8)",
//     },
//   }}
// >
//   <DownloadIcon />
// </IconButton>

//                   {/* Left Navigation Button */}
//                   {allImages.length > 1 && (
//                     <IconButton
//                       onClick={prevImage}
//                       sx={{
//                         position: 'absolute',
//                         left: 8,
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         backgroundColor: 'rgba(255, 255, 255, 0.8)',
//                         '&:hover': {
//                           backgroundColor: 'rgba(255, 255, 255, 0.9)',
//                         },
//                       }}
//                     >
//                       <ChevronLeftIcon />
//                     </IconButton>
//                   )}
                  
//                   {/* Right Navigation Button */}
//                   {allImages.length > 1 && (
//                     <IconButton
//                       onClick={nextImage}
//                       sx={{
//                         position: 'absolute',
//                         right: 8,
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         backgroundColor: 'rgba(255, 255, 255, 0.8)',
//                         '&:hover': {
//                           backgroundColor: 'rgba(255, 255, 255, 0.9)',
//                         },
//                       }}
//                     >
//                       <ChevronRightIcon />
//                     </IconButton>
//                   )}
                  
//                   {/* Image counter */}
//                   <Box
//                     position="absolute"
//                     bottom={8}
//                     right={8}
//                     sx={{
//                       backgroundColor: 'rgba(0, 0, 0, 0.7)',
//                       color: 'white',
//                       padding: '2px 8px',
//                       borderRadius: '12px',
//                       fontSize: '0.75rem'
//                     }}
//                   >
//                     {currentImageIndex + 1} / {allImages.length}
//                   </Box>
//                 </>
//               ) : (
//                 <Box
//                   sx={{
//                     width: '100%',
//                     height: '100%',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     backgroundColor: '#f5f5f5',
//                     borderRadius: 2
//                   }}
//                 >
//                   <NoPhotographyIcon sx={{ fontSize: 48, color: '#ccc', mb: 1 }} />
//                   <Typography variant="body2" color="text.secondary">
//                     No image available
//                   </Typography>
//                 </Box>
//               )}
//             </Box>

//             {/* Dots Indicator - Only show if more than 1 image */}
//             {allImages.length > 1 && (
//               <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, gap: 0.5 }}>
//                 {allImages.map((_, index) => (
//                   <Box
//                     key={index}
//                     onClick={() => handleImageClick(index)}
//                     sx={{
//                       width: 8,
//                       height: 8,
//                       borderRadius: '50%',
//                       backgroundColor: index === currentImageIndex ? '#1976d2' : '#ccc',
//                       cursor: 'pointer',
//                       '&:hover': {
//                         backgroundColor: index === currentImageIndex ? '#1976d2' : '#aaa',
//                       }
//                     }}
//                   />
//                 ))}
//               </Box>
//             )}

//             <CardContent sx={{ p: 0, pt: 2 }}>
//               {/* Reserve Price */}
//               <Box
//                 sx={{
//                   backgroundColor: "#fff1f0",
//                   p: 2,
//                   borderRadius: 2,
//                   mb: 2,
//                 }}
//               >
//                 <Typography variant="body2" color="text.secondary">
//                   Reserve Price
//                 </Typography>
//                 <Typography variant="h6" color="error" fontWeight={700}>
//                   ₹{property.reserve_price}
//                 </Typography>
//               </Box>

//               {/* Property Info */}
//               <Typography variant="body2">
//                 <b>Property type:</b> {property.property_type || "Not specified"}
//               </Typography>

//               <Typography variant="body2" mt={1}>
//                 <b>City/Town:</b> {property.city_town || "Not specified"} / {property.area_town || "Not specified"}
//               </Typography>

//   <Box mt={1}>
//   <Box
//     onClick={handleLocationClick}
//     sx={{
//       cursor: "pointer",
//       borderRadius: 1,
//       p: 0.5,
//       "&:hover": {
//         backgroundColor: "#f0f0f0",
//       },
//     }}
//   >
//     {/* First Row */}
//     <Box sx={{ display: "flex", alignItems: "center" }}>
//       <Typography variant="body2">
//         <b>Location:</b>
//       </Typography>

//       {locationLoading ? (
//         <CircularProgress size={16} sx={{ ml: 0.5 }} />
//       ) : (
//         <LocationOnIcon
//           sx={{ color: "#1976d2", fontSize: "1rem", ml: 0.5 }}
//         />
//       )}
      
//       <Typography variant="body2" sx={{ ml: 1, color: "#555" }}>
//         {property.location?.split(",")[0]}
//       </Typography>
//     </Box>

//     {/* Second Row (remaining address) */}
//     <Typography
//      variant="body2"
//   sx={{
//     color: "#555",
//     lineHeight: 1.6,          // ✅ more vertical spacing
//     textAlign: "justify",     // ✅ left + right align
//     textJustify: "inter-word",// ✅ better spacing between words
//                      // ✅ more gap from above
    
//   }}
// >
//       {property.location
//         ?.split(",")
//         .slice(1)
//         .join(",")}
//     </Typography>
//   </Box>
// </Box>
//               <Typography variant="body2" mt={1}>
//                 <b>Area:</b> {property.area || "Not specified"} {property.units || ""}
//               </Typography>

//               {/* Details Box */}
//               <Box
//                 sx={{
//                   backgroundColor: "#f9f9f9",
//                   p: 2,
//                   borderRadius: 2,
//                   mt: 2,
//                 }}
//               >
//                 <InfoRow 
//                   label="EMD Amount" 
//                   value={property.emd_amount ? `₹${property.emd_amount}` : "Not specified"} 
//                 />
//                 <InfoRow 
//                   label="Bid Increment" 
//                   value={property.bid_increment ? `₹${property.bid_increment}` : "Not specified"} 
//                 />
//                 <InfoRow 
//                   label="EMD Submission" 
//                   value={property.emd_submission ? new Date(property.emd_submission).toLocaleString() : "Not specified"} 
//                 />
//                 <InfoRow 
//                   label="Auction Start" 
//                   value={property.auction_start_datetime ? new Date(property.auction_start_datetime).toLocaleString() : "Not specified"} 
//                 />
//                 <InfoRow 
//                   label="Auction End" 
//                   value={property.auction_end_datetime ? new Date(property.auction_end_datetime).toLocaleString() : "Not specified"} 
//                 />
//                 <InfoRow 
//                   label="Possession" 
//                   value={`${property.possession_status || "Not specified"} / ${property.possession || "Not specified"}`} 
//                 />
//               </Box>

//               {/* <Button fullWidth variant="contained" sx={{ mt: 2 }}>
//                 Download Auction File
//               </Button> */}

//               <Divider sx={{ my: 2 }} />

//               {/* Bank Info */}
//               <Box display="flex" justifyContent="space-between" alignItems="center" mb={7}>
//                 <Box>
//                   <Typography fontWeight={600}>{property.bank_name || "Bank name not specified"}</Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Contact: {property.bank_contact_details || "Not available"}
//                   </Typography>
//                 </Box>
//                 <Button
//                   variant="outlined"
//                   size="small"
//                   startIcon={<CallIcon />}
//                   sx={{ textTransform: "none" }}
//                   onClick={handleCallButtonClick}
//                 >
//                   Call
//                 </Button>
//               </Box>
                 
      
//             </CardContent>
//           </Box>
//         </Card>
//       </Box>
     
//                {/* Add these alert components */}
//       {showSuccess && (
//         <CopySuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}
      
//       {showFailure && (
//         <CopyFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}


//       {/* Fixed Bottom Navbar */}
//       <Box sx={{ 
//         position: "fixed", 
//         bottom: 0, 
//         left: 0, 
//         right: 0,
//         zIndex: 1000
//       }}>
//         <BottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// /* Reusable Row */
// const InfoRow = ({ label, value }) => (
//   <Box display="flex" justifyContent="space-between" mb={1}>
//     <Typography variant="body2" color="text.secondary">
//       {label}
//     </Typography>
//     <Typography variant="body2" fontWeight={600}>
//       {value}
//     </Typography>
//   </Box>
// );

// export default AuctionPropertyCardDynamic;

import React, { useEffect, useState } from "react";
import {
  Card,
  CardMedia,
  Typography,
  Box,
  Button,
  CardContent,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DownloadIcon from "@mui/icons-material/Download";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import GavelIcon from "@mui/icons-material/Gavel";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import HomeIcon from '@mui/icons-material/Home';
import PlaceIcon from "@mui/icons-material/Place";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EventIcon from "@mui/icons-material/Event";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PersonIcon from "@mui/icons-material/Person";
import { BASE_URL } from "../../Api/ApiUrls";
import BottomNavbar from "./../Rent Module/BottomNavbar/BottomNavbar";
import CopyFailureAlert from "../Alertpage/CopyAlert/CopyFailureAlert";
import CopySuccessAlert from "../Alertpage/CopyAlert/CopySuccessAlert";
import {
  CheckCircle, Security, Bolt, Groups, Pool, FitnessCenter, SportsEsports,
  DirectionsRun, ChildCare, Park, SelfImprovement, MeetingRoom, Theaters, Work,
  ElectricCar, LocalParking, Water, Videocam, ChildFriendly, Spa, HotTub,
  SportsTennis, SportsBasketball, SportsCricket, SportsSoccer, DirectionsBike,
  LocalLibrary, LocalCafe, Event, Hotel, Texture, Kitchen, Bathtub, FormatPaint,
  Train, Flight, DirectionsBus, School, LocalHospital, ShoppingCart,
  ApartmentOutlined, Description, Gavel, AccountBalance,
} from '@mui/icons-material';

// ✅ NEW: Add the AddPropertyCards component
import AddPropertyCards from "../AddsProducts/AddPropertyCards";

const BANK_API = `${BASE_URL}/auction-property/`;

const COLORS = {
  primary: '#8B4A2B', primaryDark: '#6B3620', cardBg: '#FFFFFF',
  blue: '#1565C0', textSecondary: '#8A7A6D', textDark: '#2B2118', border: '#F0E6DA',
};

const AMENITY_CATEGORIES = [
  "Recreation", "Fitness & Wellness", "Sports", "Security",
  "Utilities", "Building Facilities", "Family & Convenience",
];

const AMENITY_CATEGORY_MAP = {
  "Swimming Pool": "Recreation", "Kids Pool": "Recreation", "Club House": "Recreation",
  "Indoor Games": "Recreation", "Mini Theatre": "Recreation", "Party Hall": "Recreation",
  "Library": "Recreation", "Cafe": "Recreation", "Guest Rooms": "Recreation",
  "Gym": "Fitness & Wellness", "Yoga Room": "Fitness & Wellness", "Jogging Track": "Fitness & Wellness",
  "Cycling Track": "Fitness & Wellness", "Spa": "Fitness & Wellness", "Sauna": "Fitness & Wellness",
  "Steam Room": "Fitness & Wellness", "Meditation Area": "Fitness & Wellness", "Fitness Centre": "Fitness & Wellness",
  "Tennis Court": "Sports", "Basketball Court": "Sports", "Badminton Court": "Sports",
  "Cricket Net": "Sports", "Football Field": "Sports", "Table Tennis": "Sports",
  "Volleyball Court": "Sports", "Skating Area": "Sports", "Kids Play Area": "Sports",
  "24x7 Security": "Security", "CCTV Surveillance": "Security", "Video Door Phone": "Security",
  "Intercom": "Security", "Gated Entry": "Security", "Visitor Mgmt": "Security",
  "Fire Safety": "Security", "Access Control": "Security", "Emergency Exit": "Security",
  "Power Backup": "Utilities", "Water Supply": "Utilities", "Rainwater Harvesting": "Utilities",
  "Sewage Treatment": "Utilities", "Waste Mgmt": "Utilities", "Solar Power": "Utilities",
  "EV Charging": "Utilities", "Gas Pipeline": "Utilities", "STP / WTP": "Utilities",
  "High Speed Lift": "Building Facilities", "Lobby": "Building Facilities", "Reception": "Building Facilities",
  "Waiting Area": "Building Facilities", "Basement Parking": "Building Facilities",
  "Maintenance": "Building Facilities", "Housekeeping": "Building Facilities",
  "Service Lift": "Building Facilities", "Common Terrace": "Building Facilities",
  "Creche/Day Care": "Family & Convenience", "Senior Citizen Area": "Family & Convenience",
  "Convenience Store": "Family & Convenience", "Pharmacy": "Family & Convenience",
  "ATM": "Family & Convenience", "Salon": "Family & Convenience", "Laundry": "Family & Convenience",
  "Medical Centre": "Family & Convenience",
};

const CATEGORY_KEYWORDS = [
  { cat: "Recreation", keys: ["pool", "club house", "indoor games", "mini theatre", "party hall", "library", "cafe", "guest room"] },
  { cat: "Fitness & Wellness", keys: ["gym", "yoga", "jogging", "cycling", "spa", "sauna", "steam", "meditation", "fitness"] },
  { cat: "Sports", keys: ["tennis", "basketball", "badminton", "cricket", "football", "table tennis", "volleyball", "skating", "kids play", "play area"] },
  { cat: "Security", keys: ["security", "cctv", "video door", "intercom", "gated entry", "visitor", "fire safety", "access control", "emergency exit"] },
  { cat: "Utilities", keys: ["power backup", "water supply", "rainwater", "rain water", "sewage", "waste", "solar", "ev charging", "gas pipeline", "stp", "wtp"] },
  { cat: "Building Facilities", keys: ["lift", "lobby", "reception", "waiting", "basement parking", "maintenance", "housekeeping", "terrace"] },
  { cat: "Family & Convenience", keys: ["creche", "day care", "senior citizen", "convenience", "store", "pharmacy", "atm", "salon", "laundry", "medical"] },
];

const getAmenityCategory = (name = "") => {
  if (AMENITY_CATEGORY_MAP[name]) return AMENITY_CATEGORY_MAP[name];
  const lower = String(name).toLowerCase();
  for (const { cat, keys } of CATEGORY_KEYWORDS) {
    if (keys.some((k) => lower.includes(k))) return cat;
  }
  return "Other";
};

const groupAmenitiesByCategory = (amenities = []) => {
  const groups = {};
  amenities.forEach((name) => {
    const cat = getAmenityCategory(name);
    if (!groups[cat]) groups[cat] = [];
    groups[cat].push(name);
  });
  return groups;
};

const ICON_KEYWORDS = [
  { keys: ['security', 'cctv', 'guard', '24'], icon: Security },
  { keys: ['power', 'backup', 'electrical', 'bolt'], icon: Bolt },
  { keys: ['club', 'community'], icon: Groups },
  { keys: ['swim', 'pool'], icon: Pool },
  { keys: ['gym', 'fitness'], icon: FitnessCenter },
  { keys: ['indoor', 'game', 'sports esports'], icon: SportsEsports },
  { keys: ['jog', 'run', 'track'], icon: DirectionsRun },
  { keys: ['child', 'kid', 'play'], icon: ChildCare },
  { keys: ['senior', 'park', 'garden', 'landscape'], icon: Park },
  { keys: ['yoga', 'meditation'], icon: SelfImprovement },
  { keys: ['multipurpose', 'hall', 'banquet', 'party'], icon: MeetingRoom },
  { keys: ['theatre', 'theater', 'cinema'], icon: Theaters },
  { keys: ['co-work', 'cowork', 'office', 'business', 'lounge'], icon: Work },
  { keys: ['ev', 'electric', 'charging'], icon: ElectricCar },
  { keys: ['visitor', 'parking'], icon: LocalParking },
  { keys: ['rain', 'water', 'harvest'], icon: Water },
  { keys: ['cctv', 'camera', 'surveillance'], icon: Videocam },
  { keys: ['kids pool', 'child pool'], icon: ChildFriendly },
  { keys: ['spa'], icon: Spa },
  { keys: ['sauna', 'hot tub', 'jacuzzi'], icon: HotTub },
  { keys: ['badminton', 'tennis'], icon: SportsTennis },
  { keys: ['basketball'], icon: SportsBasketball },
  { keys: ['cricket', 'net'], icon: SportsCricket },
  { keys: ['football', 'soccer', 'turf'], icon: SportsSoccer },
  { keys: ['cycling', 'bike'], icon: DirectionsBike },
  { keys: ['library', 'reading'], icon: LocalLibrary },
  { keys: ['cafe', 'coffee'], icon: LocalCafe },
  { keys: ['event', 'auditorium'], icon: Event },
  { keys: ['hotel', 'guest', 'room'], icon: Hotel },
  { keys: ['flooring', 'floor', 'texture'], icon: Texture },
  { keys: ['kitchen', 'modular'], icon: Kitchen },
  { keys: ['bathroom', 'bath', 'toilet'], icon: Bathtub },
  { keys: ['painting', 'paint'], icon: FormatPaint },
  { keys: ['smart', 'home', 'automation'], icon: HomeIcon },
  { keys: ['door', 'window'], icon: MeetingRoom },
  { keys: ['metro', 'train', 'railway'], icon: Train },
  { keys: ['airport', 'flight'], icon: Flight },
  { keys: ['bus', 'transit'], icon: DirectionsBus },
  { keys: ['school', 'college', 'education'], icon: School },
  { keys: ['hospital', 'clinic', 'medical'], icon: LocalHospital },
  { keys: ['mall', 'shopping', 'market'], icon: ShoppingCart },
  { keys: ['it park', 'tech', 'office park'], icon: ApartmentOutlined },
  { keys: ['brochure', 'document', 'pdf'], icon: Description },
  { keys: ['legal', 'rera', 'approval'], icon: Gavel },
  { keys: ['bank', 'loan', 'finance'], icon: AccountBalance },
];

const resolveIcon = (label = '') => {
  const lower = String(label).toLowerCase();
  for (const { keys, icon } of ICON_KEYWORDS) {
    if (keys.some((k) => lower.includes(k))) return icon;
  }
  return CheckCircle;
};

const IconGrid = ({ items, emptyText }) => {
  if (!items || items.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 1 }}>
        {emptyText || 'Not available'}
      </Typography>
    );
  }
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
      {items.map((raw) => {
        const name = typeof raw === 'string' ? raw : raw.name;
        const IconComp = resolveIcon(name);
        return (
          <Box
            key={name}
            sx={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
              borderRadius: '10px', border: `1px solid ${COLORS.border}`,
              backgroundColor: COLORS.cardBg, minHeight: '60px', justifyContent: 'center', overflow: 'hidden',
            }}
          >
            <IconComp sx={{ fontSize: 24, color: COLORS.primary }} />
            <Typography sx={{ fontSize: '10.5px', fontWeight: 600, color: COLORS.textDark, lineHeight: 1.2, wordBreak: 'break-word' }}>
              {name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

const SectionHeaderWithViewAll = ({ title, onViewAll, expanded }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>{title}</Typography>
    {onViewAll && (
      <Typography variant="body2" onClick={onViewAll} sx={{ color: COLORS.blue, fontWeight: 600, cursor: 'pointer' }}>
        {expanded ? 'Show Less' : 'View All'}
      </Typography>
    )}
  </Box>
);

const EmptyText = ({ children }) => (
  <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 3 }}>
    {children}
  </Typography>
);

const AuctionPropertyCardDynamic = () => { 
  const { id } = useParams();
  const navigate = useNavigate();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [locationLoading, setLocationLoading] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [allImages, setAllImages] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
    const [showAllHighlights, setShowAllHighlights] = useState(false);
  const [selectedAmenityCategory, setSelectedAmenityCategory] = useState('All');

  useEffect(() => {
    const fetchProperty = async () => {
      try {
        const res = await axios.get(BANK_API);
        const dataArray = res.data?.data || res.data?.results || res.data;

        if (Array.isArray(dataArray)) {
          const found = dataArray.find(
            (item) => String(item.bankprop_id) === id
          );
          if (found) {
            setProperty(found);
            if (found.bank_pro_doc && found.bank_pro_doc.length > 0) {
              const images = found.bank_pro_doc.map((doc) => ({
                id: doc.doc_id,
                url: doc.document,
                uploaded_at: doc.uploaded_at,
              }));
              setAllImages(images);
            } else {
              setAllImages([]);
            }
          }
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching property:", err);
        setLoading(false);
      }
    };
    fetchProperty();
  }, [id]);

  const formatPropertyId = (id) =>
    `BAP${String(id).padStart(4, "0")}`;

  const handleLocationClick = () => {
    if (!property || !property.lat || !property.long) {
      window.alert("Location coordinates not available");
      return;
    }
    setLocationLoading(true);
    const openInMaps = (url) => {
      setLocationLoading(false);
      window.open(url, "_blank", "noopener,noreferrer");
    };
    const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      `${property.lat},${property.long}`
    )}`;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${position.coords.latitude},${position.coords.longitude}&destination=${property.lat},${property.long}&travelmode=driving`;
          openInMaps(mapsUrl);
        },
        () => openInMaps(fallbackUrl),
        { timeout: 10000 }
      );
    } else {
      openInMaps(fallbackUrl);
    }
  };

  const handleCallButtonClick = () => {
    if (property?.bank_contact_details) {
      navigator.clipboard
        .writeText(property.bank_contact_details)
        .then(() => {
          setAlertMessage(
            `Contact number copied: ${property.bank_contact_details}\n\nProperty ID: ${formatPropertyId(
              property.bankprop_id
            )}`
          );
          setShowSuccess(true);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
          setAlertMessage("Failed to copy contact number");
          setShowFailure(true);
        });
    } else {
      setAlertMessage("Contact number not available");
      setShowFailure(true);
    }
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith("http")) return imagePath;
    return `${BASE_URL}${imagePath}`;
  };

  const nextImage = () =>
    setCurrentImageIndex((p) => (p === allImages.length - 1 ? 0 : p + 1));
  const prevImage = () =>
    setCurrentImageIndex((p) => (p === 0 ? allImages.length - 1 : p - 1));
  const handleImageClick = (i) => setCurrentImageIndex(i);

  const handleDownloadImage = async () => {
    const currentImage = allImages[currentImageIndex];
    if (!currentImage) return;
    try {
      const imageUrl = getImageUrl(currentImage.url);
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `/Auction_Property_${formatPropertyId(
        property.bankprop_id
      )}_${currentImageIndex + 1}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      window.alert("Failed to download image");
    }
  };

  const uniqueNames = (list = []) => [
  ...new Set(list.map((x) => (x?.name || '').trim()).filter(Boolean)),
];

const highlightNames = uniqueNames(property.property_highlights);
const amenityNames = uniqueNames(property.property_amenities);

const visibleHighlights = showAllHighlights ? highlightNames : highlightNames.slice(0, 8);

const amenityGroups = groupAmenitiesByCategory(amenityNames);
const presentAmenityCategories = AMENITY_CATEGORIES.filter((c) => amenityGroups[c]?.length > 0);
if (amenityGroups["Other"]?.length) presentAmenityCategories.push("Other");

const amenityCategoriesToShow =
  selectedAmenityCategory === 'All'
    ? presentAmenityCategories
    : presentAmenityCategories.filter((c) => c === selectedAmenityCategory);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#F8F3EC",
        }}
      >
        <CircularProgress sx={{ color: "#8A6A3D" }} />
      </Box>
    );
  }

  if (!property) {
    return (
      <Box
        sx={{
          p: 2,
          textAlign: "center",
          backgroundColor: "#F8F3EC",
          minHeight: "100vh",
        }}
      >
        <Typography>Property not found</Typography>
      </Box>
    );
  }

  const currentImage =
    allImages.length > 0 ? allImages[currentImageIndex] : null;
  const dateStr = property.created_at
    ? new Date(property.created_at).toLocaleDateString("en-GB")
    : "-";

  return (
    <Box
      sx={{
        width: "100vw",
        minHeight: "100vh",
        backgroundColor: "#F8F3EC",
        pb: 10,
      }}
    >
      {/* ===== FIXED HEADER (dark brown) ===== */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          bgcolor: "#3E2A1E",
          color: "white",
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "center",
        }}
      >
        <IconButton
          onClick={() => navigate(-1)}
          sx={{ color: "white", mr: 1, p: 0.5 }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
        </IconButton>
        <Typography
          sx={{
            flex: 1,
            fontSize: "1rem",
            fontWeight: 600,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          Auction Property
        </Typography>
        <Box textAlign="right">
          <Typography
            sx={{
              display: "block",
              fontSize: "0.66rem",
              opacity: 0.9,
              lineHeight: 1.2,
            }}
          >
            ID: {formatPropertyId(property.bankprop_id)}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 0.4,
              mt: 0.2,
            }}
          >
            <CalendarTodayIcon sx={{ fontSize: 10, opacity: 0.9 }} />
            <Typography sx={{ fontSize: "0.64rem", opacity: 0.9 }}>
              Date: {dateStr}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ===== BODY ===== */}
      <Box sx={{ pt: "60px", px: 1 }}>
        {/* ── Image carousel ── */}
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: 200,
            borderRadius: "12px",
            overflow: "hidden",
            bgcolor: "#f5f5f5",
            mb: 1.5,
            border: "1px solid #E8DCC8",
          }}
        >
          {allImages.length > 0 ? (
            <>
              <CardMedia
                component="img"
                image={getImageUrl(currentImage.url)}
                alt={`Property ${currentImageIndex + 1}`}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/400x200?text=Image+Not+Available";
                }}
              />

              <IconButton
                onClick={handleDownloadImage}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                }}
              >
                <DownloadIcon />
              </IconButton>

              {allImages.length > 1 && (
                <IconButton
                  onClick={prevImage}
                  sx={{
                    position: "absolute",
                    left: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    backgroundColor: "rgba(255,255,255,0.8)",
                    "&:hover": { backgroundColor: "rgba(255,255,255,0.9)" },
                  }}
                >
                  <ChevronLeftIcon />
                </IconButton>
              )}

              {allImages.length > 1 && (
                <IconButton
                  onClick={nextImage}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    backgroundColor: "rgba(255,255,255,0.8)",
                    "&:hover": { backgroundColor: "rgba(255,255,255,0.9)" },
                  }}
                >
                  <ChevronRightIcon />
                </IconButton>
              )}

              <Box
                sx={{
                  position: "absolute",
                  bottom: 8,
                  right: 8,
                  backgroundColor: "rgba(0,0,0,0.7)",
                  color: "white",
                  padding: "2px 8px",
                  borderRadius: "12px",
                  fontSize: "0.75rem",
                }}
              >
                {currentImageIndex + 1} / {allImages.length}
              </Box>
            </>
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <NoPhotographyIcon
                sx={{ fontSize: 48, color: "#ccc", mb: 1 }}
              />
              <Typography variant="body2" color="text.secondary">
                No image available
              </Typography>
            </Box>
          )}
        </Box>

        {/* Dots */}
        {allImages.length > 1 && (
          <Box
            sx={{ display: "flex", justifyContent: "center", mb: 1.5, gap: 0.5 }}
          >
            {allImages.map((_, index) => (
              <Box
                key={index}
                onClick={() => handleImageClick(index)}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:
                    index === currentImageIndex ? "#8A6A3D" : "#ccc",
                  cursor: "pointer",
                }}
              />
            ))}
          </Box>
        )}

        {/* ── Reserve Price card ── */}
        <Box
          sx={{
            position: "relative",
            bgcolor: "#FFFFFF",
            border: "1px solid #E8DCC8",
            borderRadius: "12px",
            p: 1.5,
            mb: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 1.2,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              backgroundColor: "#FBF5ED",
              border: "1px solid #E8DCC8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <GavelIcon sx={{ color: "#8A6A3D", fontSize: 22 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.72rem", color: "#777" }}>
              Reserve Price
            </Typography>
            <Typography
              sx={{
                color: "#5C3D1E",
                fontWeight: 800,
                fontSize: "1.15rem",
                lineHeight: 1.2,
              }}
            >
              ₹{property.reserve_price || "NA"}
            </Typography>
          </Box>
          <GavelIcon
            sx={{
              position: "absolute",
              right: 12,
              bottom: -6,
              fontSize: 60,
              color: "#F5DEB3",
              opacity: 0.5,
              transform: "rotate(-25deg)",
              pointerEvents: "none",
            }}
          />
        </Box>

        {/* ── Info rows ── */}
        <InfoIconRow
          icon={<HomeWorkIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />}
          label="Property type"
          value={property.property_type || "Not specified"}
        />

        <InfoIconRow
          icon={<PlaceIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />}
          label="City/Town"
          value={`${property.city_town || "Not specified"} / ${
            property.area_town || "Not specified"
          }`}
        />

        {/* Location row (clickable) */}
        <Box
          onClick={handleLocationClick}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.2,
            mb: 1.2,
            cursor: "pointer",
            borderRadius: 1,
            p: 0.4,
            "&:hover": { backgroundColor: "#F0E6D6" },
          }}
        >
          <IconCircle>
            {locationLoading ? (
              <CircularProgress size={14} sx={{ color: "#8A6A3D" }} />
            ) : (
              <LocationOnIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />
            )}
          </IconCircle>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.72rem", color: "#777" }}>
              Location
            </Typography>
            <Typography
              sx={{
                fontSize: "0.85rem",
                fontWeight: 600,
                color: "#222",
                lineHeight: 1.4,
                wordBreak: "break-word",
              }}
            >
              {property.location || "Not specified"}
            </Typography>
          </Box>
        </Box>

        <InfoIconRow
          icon={<CropSquareIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />}
          label="Area"
          value={`${property.area || "Not specified"} ${
            property.units || ""
          }`.trim()}
        />

        {/* ✅ NEW: Add Property Cards (advertisements) — above the Details card */}
        <Box sx={{ mb: 1.5 }}>
          <AddPropertyCards panel="auction" />
        </Box>

        {/* ── Details card ── */}
        <Box
          sx={{
            bgcolor: "#FFFFFF",
            border: "1px solid #E8DCC8",
            borderRadius: "12px",
            p: 1.5,
            mt: 1.5,
            mb: 1.5,
          }}
        >
          <DetailRow
            icon={<AttachMoneyIcon sx={{ fontSize: 14 }} />}
            label="EMD Amount"
            value={
              property.emd_amount
                ? `₹${property.emd_amount}`
                : "Not specified"
            }
          />
          <DetailRow
            icon={<TrendingUpIcon sx={{ fontSize: 14 }} />}
            label="Bid Increment"
            value={
              property.bid_increment
                ? `₹${property.bid_increment}`
                : "Not specified"
            }
          />
          <DetailRow
            icon={<EventIcon sx={{ fontSize: 14 }} />}
            label="EMD Submission"
            value={
              property.emd_submission
                ? new Date(property.emd_submission).toLocaleString()
                : "Not specified"
            }
          />
          <DetailRow
            icon={<PlayArrowIcon sx={{ fontSize: 14 }} />}
            label="Auction Start"
            value={
              property.auction_start_datetime
                ? new Date(property.auction_start_datetime).toLocaleString()
                : "Not specified"
            }
          />
          <DetailRow
            icon={<StopIcon sx={{ fontSize: 14 }} />}
            label="Auction End"
            value={
              property.auction_end_datetime
                ? new Date(property.auction_end_datetime).toLocaleString()
                : "Not specified"
            }
          />
          <DetailRow
            icon={<CheckCircleIcon sx={{ fontSize: 14 }} />}
            label="Possession"
            value={`${property.possession_status || "Not specified"} / ${
              property.possession || "Not specified"
            }`}
            last
          />
        </Box>

        {/* ===== PROPERTY HIGHLIGHTS ===== */}
        {highlightNames.length > 0 && (
          <Box sx={{ px: 0.5, mb: 1 }}>
            <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
              <CardContent sx={{ p: 0.5 }}>
                <SectionHeaderWithViewAll
                  title="Property Highlights"
                  onViewAll={highlightNames.length > 8 ? () => setShowAllHighlights(!showAllHighlights) : null}
                  expanded={showAllHighlights}
                />
                <IconGrid items={visibleHighlights} emptyText="No highlights available for this property" />
              </CardContent>
            </Card>
          </Box>
        )}
        
        {/* ===== AMENITIES ===== */}
        {amenityNames.length > 0 && (
          <Box sx={{ px: 0.5, mb: 1 }}>
            <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
              <CardContent sx={{ p: 0.5 }}>
                <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>
                  Amenities
                </Typography>
        
                <Box
                  sx={{
                    mb: 2, mt: 1, overflowX: 'auto', whiteSpace: 'nowrap',
                    borderBottom: `1px solid ${COLORS.border}`,
                    '&::-webkit-scrollbar': { display: 'none' },
                  }}
                >
                  <Box sx={{ display: 'inline-flex' }}>
                    {['All', ...presentAmenityCategories].map((cat) => {
                      const isActive = selectedAmenityCategory === cat;
                      const count = cat === 'All' ? amenityNames.length : amenityGroups[cat]?.length || 0;
                      return (
                        <Box
                          key={cat}
                          onClick={() => setSelectedAmenityCategory(cat)}
                          sx={{
                            px: 1.5, py: 1, cursor: 'pointer', flexShrink: 0,
                            borderBottom: isActive ? `2px solid ${COLORS.primaryDark}` : '2px solid transparent',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '13px',
                              fontWeight: isActive ? 700 : 500,
                              color: isActive ? COLORS.primaryDark : COLORS.textSecondary,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {cat} ({count})
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
        
                {amenityCategoriesToShow.map((cat) => (
                  <Box key={cat} sx={{ mb: 2 }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark, mb: 1 }}>
                      {cat}
                    </Typography>
                    <IconGrid items={amenityGroups[cat]} />
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Box>
        )}

        {/* ── Bank card ── */}
        <Box
          sx={{
            bgcolor: "#FFFFFF",
            border: "1px solid #E8DCC8",
            borderRadius: "12px",
            p: 1.5,
            mb: 3,
            display: "flex",
            alignItems: "center",
            gap: 1.2,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor: "#FBF5ED",
              border: "1px solid #E8DCC8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <PersonIcon sx={{ color: "#8A6A3D", fontSize: 20 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              sx={{ fontSize: "0.9rem", fontWeight: 700, color: "#222" }}
            >
              {property.bank_name || "Bank name not specified"}
            </Typography>
            <Typography sx={{ fontSize: "0.74rem", color: "#777" }}>
              Contact: {property.bank_contact_details || "Not available"}
            </Typography>
          </Box>
          <Button
            size="small"
            onClick={handleCallButtonClick}
            startIcon={<CallIcon sx={{ fontSize: 14 }} />}
            sx={{
              textTransform: "none",
              fontSize: "0.75rem",
              fontWeight: 600,
              color: "#5C3D1E",
              backgroundColor: "#F5DEB3",
              border: "1px solid #E8C99A",
              borderRadius: 999,
              px: 1.5,
              py: 0.5,
              "&:hover": { backgroundColor: "#eccf95" },
            }}
          >
            Call
          </Button>
        </Box>
      </Box>

      {/* Alerts */}
      {showSuccess && (
        <CopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            setAlertMessage("");
          }}
        />
      )}
      {showFailure && (
        <CopyFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowFailure(false);
            setAlertMessage("");
          }}
        />
      )}

      {/* Fixed Bottom Navbar */}
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
        }}
      >
        <BottomNavbar />
      </Box>
    </Box>
  );
};

/* ───────── Reusable subcomponents ───────── */

const IconCircle = ({ children }) => (
  <Box
    sx={{
      width: 36,
      height: 36,
      borderRadius: "50%",
      backgroundColor: "#FBF5ED",
      border: "1px solid #E8DCC8",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
  >
    {children}
  </Box>
);

const InfoIconRow = ({ icon, label, value }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
    <IconCircle>{icon}</IconCircle>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: "0.72rem", color: "#777" }}>
        {label}
      </Typography>
      <Typography
        sx={{ fontSize: "0.88rem", fontWeight: 700, color: "#222" }}
      >
        {value}
      </Typography>
    </Box>
  </Box>
);

const DetailRow = ({ icon, label, value, last }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      py: 1.1,
      borderBottom: last ? "none" : "1px solid #F0E6D6",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: "50%",
          backgroundColor: "#FBF5ED",
          border: "1px solid #E8DCC8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#8A6A3D",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Typography
        sx={{ fontSize: "0.8rem", color: "#555", fontWeight: 500 }}
      >
        {label}
      </Typography>
    </Box>
    <Typography
      sx={{ fontSize: "0.84rem", fontWeight: 700, color: "#222" }}
    >
      {value}
    </Typography>
  </Box>
);

export default AuctionPropertyCardDynamic;